/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
import { Controller } from 'react-hook-form';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import ConceptCategorizingArray from '../shared/ConceptCategorizingArray';
import EmentorArray from '../shared/EmentorArray';

const ConceptCategorizing = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir, possiblePages } = props;

  return (
    <div>
      <NumberedHeading
        number="1"
        title="Statements"
        instructions="Using the controls below, please add statements for the activity"
      />
      <Controller
        control={control}
        name="content.core"
        render={({ field }) => (
          <ConceptCategorizingArray
            inputDir={inputDir}
            materialPages={possiblePages}
            {...{ control, errors }}
          />
        )}
      />

      <NumberedHeading
        number="2"
        title="eMentor Notes"
        instructions="Using the controls below, add any supplemental content to this page"
      />
      <Controller
        control={control}
        name="content.eMentor"
        render={({ field }) => <EmentorArray {...{ control, errors }} />}
      />
    </div>
  );
};

export default ConceptCategorizing;
